import writeXlsxFile from "write-excel-file";
import { toast } from "react-toastify";
// service
import { getSurveysReport } from "../../../../utils/services/superScreen";
// utils
import { formatDateTime } from "../../../../utils/helpers/files/formatDate";

// quantidade de registros buscados por requisição na exportação
const EXPORT_LIMIT = 999;

// formata a data de criação da resposta (dd/mm/aaaa hh:mm)
function formatCreatedAt(date) {
  return date ? formatDateTime(date, "/") : "";
}

// atualiza a barra de progresso do WaitExport
function updateProgress(current, total) {
  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  const percentage = (current / total) * 100;

  if (progressBar) progressBar.style.width = `${percentage}%`;
  if (percentageBar) percentageBar.innerHTML = `${percentage.toFixed(0)}%`;
}

// busca todas as páginas do relatório e gera o arquivo xlsx
export async function createXlsx({
  idEvent,
  idSuperScreen,
  idReportSurvey,
  search,
  countData,
  activeFilter,
  setFinishExport,
  setExportInProgress,
}) {
  const schema = [
    {
      column: "Id",
      type: String,
      value: (survey) => survey.id,
    },
    {
      column: "Nome do Participante",
      type: String,
      value: (survey) => survey.loginName,
    },
    {
      column: "Email do Participante",
      type: String,
      value: (survey) => survey.loginEmail,
    },
    {
      column: "Pergunta",
      type: String,
      value: (survey) => survey.question,
    },
    {
      column: "Resposta",
      type: String,
      value: (survey) => survey.answer,
    },
    {
      column: "Acertou",
      type: String,
      value: (survey) => (survey.hit ? "Sim" : "Não"),
    },
    {
      column: "Data e Hora",
      type: String,
      value: (survey) => formatCreatedAt(survey.createdAt),
    },
  ];

  try {
    const allData = [];
    const numberOfRequisitions = Math.ceil(countData / EXPORT_LIMIT);

    for (let page = 1; page <= numberOfRequisitions; page += 1) {
      const res = await getSurveysReport(
        idEvent,
        idSuperScreen,
        idReportSurvey,
        page,
        EXPORT_LIMIT,
        search,
        activeFilter
      );

      if (res?.message !== "findOne") {
        throw new Error("Erro ao buscar dados do relatório.");
      }

      allData.push(...res.findOneTransmissionData.data);
      updateProgress(page, numberOfRequisitions);
    }

    if (allData.length > 0) {
      await writeXlsxFile(allData, {
        schema,
        fileName: "Enquetes.xlsx",
      });
    }

    setTimeout(() => {
      setFinishExport(true);
    }, 1000);
  } catch (error) {
    setExportInProgress(false);
    toast.error("Erro ao exportar relatório.");
  }
}
